import { useUnifiedSearchV2Query, SearchType } from "api";
import NotFound from "components/NotFound";
import { isEmpty } from "lodash-es";
import React, { useState } from "react";
import TopicsSearchCard from "./TopicsSearchCard";
import Loader from "./Loader";
import { SearchTag } from "layouts/MainLayout/components/Search";

interface SearchProps {
  search: string;
  close: () => void;
  isAnchor?: boolean;
  handleAddChip?: (data: SearchTag) => void;
  handleGetFilterPosts?: (data: SearchTag | undefined) => void;
}

interface IState {
  loading: boolean;
  page: number;
  hasMore: boolean;
  results: Array<any>;
  close: () => void;
}

const Topics: React.FC<SearchProps> = ({
  search,
  close,
  isAnchor,
  handleAddChip,
  handleGetFilterPosts,
}) => {
  const observer = React.useRef<any>();
  const [end, setEnd] = useState(false);

  const { data, fetchMore, loading } = useUnifiedSearchV2Query({
    variables: {
      searchText: search,
      type: SearchType.Hashtag,
      offset: 0,
      limit: 20,
    },
  });

  const lastElement = React.useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !end) {
          fetchMore({
            variables: { offset: data?.unifiedSearchV2?.length },
          }).then(({ data }) => {
            if (isEmpty(data?.unifiedSearchV2 || [])) {
              setEnd(true);
            }
          });
        }
      });
      if (node) observer.current.observe(node);
    },
    [end, setEnd, loading, data?.unifiedSearchV2?.length]
  );

  // return (
  //   <List>
  //     {data?.unifiedSearchV2?.map((topic, key, arr) => {
  //       const last = arr.length === key + 1;
  //       return (
  //         <Fragment key={key}>
  //           <ListItem disableGutters dense ref={last ? lastElement : null}>
  //             <ListItemButton component={Link} to={`/hashtag/${topic?.hashtag?.hashtag?.hashtagName}`}>
  //               <ListItemAvatar>
  //                 <Avatar>#</Avatar>
  //               </ListItemAvatar>
  //               <ListItemText
  //                 primary={<Typography variant="subtitle2">{topic?.hashtag?.hashtag?.hashtagName}</Typography>}
  //                 secondary={
  //                   <Typography variant="caption">
  //                     {inTopics ? "in Topics" : <Fragment>
  //                       <span>{topic?.hashtag?.hashtag?.postCount}</span>|<span>{topic?.hashtag?.followers}</span>
  //                     </Fragment>
  //                     }
  //                   </Typography>}
  //                 disableTypography
  //               />
  //             </ListItemButton>
  //           </ListItem>
  //           {!last && <Divider component="li" />}
  //         </Fragment>
  //       );
  //     })}
  //     {loading ? <Loader /> : isEmpty(data?.unifiedSearchV2) && <NotFound title={`No topics for "${search}"`} />}
  //   </List>
  // );

  return (
    <div
      onClick={close}
      // onClick={() => {
      //   console.log(searchContentFreeze, "FREEZE");
      //   searchContentFreeze === false ? () => close() : null;
      // }}
    >
      {data?.unifiedSearchV2?.map((item, key, arr) => {
        const last = arr.length === key + 1;
        return (
          <div key={key} ref={last ? lastElement : null}>
            <TopicsSearchCard
              topic={item?.hashtag}
              isAnchor={isAnchor}
              handleAddChip={handleAddChip}
              handleGetFilterPosts={handleGetFilterPosts}
            />
          </div>
        );
      })}
      {loading ? (
        <Loader />
      ) : (
        isEmpty(data?.unifiedSearchV2) && (
          <NotFound title={`No topics for "${search}"`} />
        )
      )}
    </div>
  );
};

export default Topics;
